const MODULE_NAME = 'fulcrum/containers/Approval/ApprovalPage'
const UPDATE_APPROVAL_LIST = 'fulcrum/containers/Approval/ApprovalPage/UPDATE_APPROVAL_LIST'
const UPDATE_APPROVAL_COUNT = 'fulcrum/containers/Approval/ApprovalPage/UPDATE_APPROVAL_COUNT'
const UPDATE_CURRENT_APPROVAL = 'fulcrum/containers/Approval/ApprovalPage/UPDATE_CURRENT_APPROVAL'
const CHANGE_CURRENT_APPROVAL = 'fulcrum/containers/Approval/ApprovalPage/CHANGE_CURRENT_APPROVAL'
const CHANGE_CURRENT_APPROVAL_START = 'fulcrum/containers/Approval/ApprovalPage/CHANGE_CURRENT_APPROVAL_START'
const CHANGE_CURRENT_APPROVAL_SUCCESS = 'fulcrum/containers/Approval/ApprovalPage/CHANGE_CURRENT_APPROVAL_SUCCESS'
const RESET_CURRENT_APPROVAL = 'fulcrum/containers/Approval/ApprovalPage/RESET_CURRENT_APPROVAL'
const CLEAR_APPROVAL_LIST = 'fulcrum/containers/Approval/ApprovalPage/CLEAR_APPROVAL_LIST'
const RESET_PRODUCT_CATEGORY_FILTER = 'fulcrum/containers/Approval/ApprovalPage/RESET_PRODUCT_CATEGORY_FILTER'
const UPDATE_PRODUCT_CATEGORY_FILTER = 'fulcrum/containers/Approval/ApprovalPage/UPDATE_PRODUCT_CATEGORY_FILTER'
const CHANGE_PRODUCT_CATEGORY_FILTER = 'fulcrum/containers/Approval/ApprovalPage/CHANGE_PRODUCT_CATEGORY_FILTER'
const APPROVAL_PAGE_MOUNT = 'fulcrum/containers/Approval/ApprovalPage/APPROVAL_PAGE_MOUNT'
const APPROVAL_PAGE_UNMOUNT = 'fulcrum/containers/Approval/ApprovalPage/APPROVAL_PAGE_UNMOUNT'
const REMOVE_APPROVAL = 'fulcrum/containers/Approval/ApprovalPage/REMOVE_APPROVAL'

const FETCH_APPROVALS = 'fulcrum/containers/Approval/ApprovalPage/FETCH_APPROVALS'
const FETCH_APPROVALS_START = 'fulcrum/containers/Approval/ApprovalPage/FETCH_APPROVALS_START'
const FETCH_APPROVALS_SUCCESS = 'fulcrum/containers/Approval/ApprovalPage/FETCH_APPROVALS_SUCCESS'
const FETCH_APPROVALS_ERROR = 'fulcrum/containers/Approval/ApprovalPage/FETCH_APPROVALS_ERROR'
const POST_APPROVAL_REJECT = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_REJECT'
const POST_APPROVAL_REJECT_START = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_REJECT_START'
const POST_APPROVAL_REJECT_SUCCESS = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_REJECT_SUCCESS'
const POST_APPROVAL_REJECT_ERROR = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_REJECT_ERROR'
const POST_APPROVAL_ACCEPT = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_ACCEPT'
const POST_APPROVAL_ACCEPT_START = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_ACCEPT_START'
const POST_APPROVAL_ACCEPT_SUCCESS = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_ACCEPT_SUCCESS'
const POST_APPROVAL_ACCEPT_ERROR = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_ACCEPT_ERROR'
const POST_APPROVAL_SKIP = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_SKIP'
const POST_APPROVAL_SKIP_START = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_SKIP_START'
const POST_APPROVAL_SKIP_SUCCESS = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_SKIP_SUCCESS'
const POST_APPROVAL_SKIP_ERROR = 'fulcrum/containers/Approval/ApprovalPage/POST_APPROVAL_SKIP_ERROR'
const FETCH_APPROVAL_COUNT = 'fulcrum/containers/Approval/ApprovalPage/FETCH_APPROVAL_COUNT'
const FETCH_APPROVAL_COUNT_START = 'fulcrum/containers/Approval/ApprovalPage/FETCH_APPROVAL_COUNT_START'
const FETCH_APPROVAL_COUNT_SUCCESS = 'fulcrum/containers/Approval/ApprovalPage/FETCH_APPROVAL_COUNT_SUCCESS'
const FETCH_APPROVAL_COUNT_ERROR = 'fulcrum/containers/Approval/ApprovalPage/FETCH_APPROVAL_COUNT_ERROR'

export {
  MODULE_NAME,
  UPDATE_APPROVAL_COUNT,
  UPDATE_APPROVAL_LIST,
  UPDATE_CURRENT_APPROVAL,
  CHANGE_CURRENT_APPROVAL,
  CHANGE_CURRENT_APPROVAL_START,
  CHANGE_CURRENT_APPROVAL_SUCCESS,
  RESET_CURRENT_APPROVAL,
  CLEAR_APPROVAL_LIST,
  RESET_PRODUCT_CATEGORY_FILTER,
  UPDATE_PRODUCT_CATEGORY_FILTER,
  CHANGE_PRODUCT_CATEGORY_FILTER,
  APPROVAL_PAGE_MOUNT,
  APPROVAL_PAGE_UNMOUNT,
  REMOVE_APPROVAL,
  FETCH_APPROVALS,
  FETCH_APPROVALS_START,
  FETCH_APPROVALS_SUCCESS,
  FETCH_APPROVALS_ERROR,
  POST_APPROVAL_REJECT,
  POST_APPROVAL_REJECT_START,
  POST_APPROVAL_REJECT_SUCCESS,
  POST_APPROVAL_REJECT_ERROR,
  POST_APPROVAL_ACCEPT,
  POST_APPROVAL_ACCEPT_START,
  POST_APPROVAL_ACCEPT_SUCCESS,
  POST_APPROVAL_ACCEPT_ERROR,
  POST_APPROVAL_SKIP,
  POST_APPROVAL_SKIP_START,
  POST_APPROVAL_SKIP_SUCCESS,
  POST_APPROVAL_SKIP_ERROR,
  FETCH_APPROVAL_COUNT,
  FETCH_APPROVAL_COUNT_START,
  FETCH_APPROVAL_COUNT_SUCCESS,
  FETCH_APPROVAL_COUNT_ERROR,
}

